// latest

import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import LoginForm from "./LoginForm";
import ResetPasswordForm from "./ResetPasswordForm";
import { userPool } from "../cognito/UserPool";
import backgroundImage from "../assets/images/backgroundImage.png";
import { isMobile, isTablet } from "react-device-detect";

function LoginPage() {
  const [formType, setFormType] = useState(
    () => localStorage.getItem("formType") || "login"
  );
  // const [isLoading, setIsLoading] = useState(true);
  const {
    currentNickname,
    setCurrentNickname,
    handleLogout,
    PlutonicuserID,
    loading,
    setLoading,
    userType,
    currentFormType,
    setCurrentFormType,
  } = useContext(AuthContext);

  // const [PlutonicuserID, setPlutonicuserID] = useState(() => localStorage.getItem('PlutonicuserID'));
  const navigate = useNavigate();

  const isPhone = isMobile && !isTablet;

  useEffect(() => {
    const savedNickname = localStorage.getItem("currentNickname"); // Use consistent key
    const savedPlutonicuserID = localStorage.getItem("PlutonicuserID");

    // if (savedNickname && savedPlutonicuserID) {
    //   setCurrentNickname(savedNickname);
    //   // setPlutonicuserID(savedPlutonicuserID);
    //   navigate("/therapy-rooms"); // Redirect if authenticated
    //   return;
    // }

    if (savedNickname && savedPlutonicuserID && !loading) {
      const storedUserType = localStorage.getItem("userType");
      if (storedUserType?.toLowerCase() === "therapist") {
        navigate("/");
      } else {
        navigate("/");
      }
    }

    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
      cognitoUser.getSession((err, session) => {
        if (err || !session.isValid()) {
          setCurrentFormType("login");
          setLoading(false);
          return;
        }

        cognitoUser.getUserAttributes((err, attributes) => {
          setLoading(false);
          if (err || !attributes) {
            setCurrentFormType("login");
            return;
          }

          const nicknameAttr = attributes.find(
            (attr) =>
              attr.Name === "nickname" || attr.Name === "custom:nickname"
          );
          const userIDAttr = attributes.find(
            (attr) => attr.Name === "custom:PlutonicuserID"
          );

          const userNickname = nicknameAttr ? nicknameAttr.Value : "";
          const id = userIDAttr ? userIDAttr.Value : null;

          if (userNickname && id) {
            setCurrentNickname(userNickname);
            // setPlutonicuserID(id);
            localStorage.setItem("currentNickname", userNickname);
            localStorage.setItem("PlutonicuserID", id);

            const storedUserType = localStorage.getItem("userType");
            if (storedUserType?.toLowerCase() === "therapist") {
              navigate("/");
            } else {
              navigate("/");
            }
          }
        });
      });
    } else {
      setLoading(false);
    }
  }, [setCurrentNickname, navigate]);

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div className="relative h-screen w-full flex flex-col items-center justify-start overflow-hidden "
    style={{
    background: "linear-gradient(to bottom, #24004266 40%, #4FCBE6 100%)",
  }}
  >
      {/* <img
        src={backgroundImage}
        alt="background"
        className="absolute inset-0 w-full h-full object-cover"
      /> */}
      <Navbar
        currentNickname={currentNickname}
        handleLogout={handleLogout}
        setCurrentFormType={setCurrentFormType}
        showButtons={false}
        PlutonicuserID={PlutonicuserID}
      />

      <div className="relative flex flex-col items-center justify-center w-full h-full">
        <div className="relative flex flex-col justify-center items-center z-0 w-[90%] max-w-[500px] h-[90%] max-h-[550px] sm:w-[80%] sm:h-[80%] md:w-[70%] md:h-[70%] p-4">
          <div
            className="relative z-20 text-center text-2xl font-bold text-black mb-6 lg:hidden"
            style={{ fontFamily: "Poppins-Semibold, Poppins, sans-serif" }}
          >
            AI Powered Mental Health Support
          </div>
          <div className="relative z-20 mt-4">
          {isPhone ? (
            <div className="text-center text-black text-lg font-medium px-4">
              Plutonic is not supported on mobile devices at this time. Please login using your computer.
            </div>
          ) : currentFormType === "login" ? (
            <LoginForm
              onLoginSuccess={(nickname, id) => {
                localStorage.setItem("currentNickname", nickname);
                localStorage.setItem("PlutonicuserID", id);
                navigate("/");
              }}
            />
          ) : (
            <ResetPasswordForm />
          )}
        </div>
        </div>
      </div>
    </div>
  );

}

export default LoginPage;
